/**
 * Cookie session + CSRF settings shared by the UI and the Cereus API.
 * These names must match the API (see docs/AUTH-CSRF-API-CONTRACT.md).
 */
export const AUTH_CSRF = {
  /** Readable cookie the API writes with the antiforgery request token. */
  cookieName: 'XSRF-TOKEN',
  /** Header the API expects the token in on POST/PUT/PATCH/DELETE. */
  headerName: 'X-XSRF-TOKEN',
};

/** API routes (relative to environment.apiUrl). */
export const AUTH_ROUTES = {
  csrf: '/auth/csrf',
  login: '/auth/login',
  verifyPin: '/auth/login/verify-pin',
  me: '/auth/me',
  logout: '/auth/logout',
  ssoLogin: '/auth/sso/login',
};

/** HTTP methods that change state and therefore need the CSRF header. */
export const CSRF_SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS', 'TRACE'];
